import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { DialogContentBase, DialogRef, DialogModule } from '@progress/kendo-angular-dialog';
import { DataStateChangeEvent, KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { TranslateModule } from '@ngx-translate/core';
import { Guid } from 'guid-typescript';
import { IBatchTemplateActivityDTO } from '@app/core/models/batch-template/batch-template-activity.model';
import { BatchTemplateService } from '@app/core/services/http-services/operative/batch-template.service';
import { KENDO_LOADER } from '@progress/kendo-angular-indicators';
import { State } from '@progress/kendo-data-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-batch-template-activities-dialog',
  templateUrl: './batch-template-activities-dialog.component.html',
  imports: [DialogModule, KENDO_GRID, KENDO_BUTTON, KENDO_LOADER, TranslateModule],
})
export class BatchTemplateActivitiesDialogComponent extends DialogContentBase implements OnInit {
  batchTemplateId: Guid;
  templateName: string;

  activities = signal<IBatchTemplateActivityDTO[]>([]);
  loading = signal<boolean>(false);

  state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  data!: { batchTemplateId: Guid; templateName: string };
  private readonly destroyRef = inject(DestroyRef);
  private readonly batchTemplateService = inject(BatchTemplateService);

  constructor() {
    super(inject(DialogRef));
  }

  ngOnInit(): void {
    this.batchTemplateId = this.data.batchTemplateId;
    this.templateName = this.data.templateName;
    this.loadActivities();
  }

  private loadActivities(): void {
    this.loading.set(true);
    this.batchTemplateService
      .getActivitiesByBatchTemplateId(this.batchTemplateId, this.state)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.activities.set(data);
          this.loading.set(false);
        },
        error: () => {
          this.loading.set(false);
        },
      });
  }

  dataStateChange(event: DataStateChangeEvent): void {
    this.state = event;
    this.loadActivities();
  }

    close() {
    this.dialog.close();
  }
}
